// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mediaViewer {
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
}

.mediaViewer__thumbBtn,
.mediaViewer__previewCard {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.mediaViewer__thumb {
  max-width: 220px;
  max-height: 160px;
  border-radius: 12px;
  display: block;
}

.mediaViewer__previewCard {
  display: grid;
  gap: 8px;
  width: min(260px, 100%);
  padding: 10px;
  border-radius: 14px;
  border: 1px solid var(--cl-border, #d8dde6);
  background: var(--cl-surface, #fff);
}

.mediaViewer__previewLabel {
  font-size: 13px;
  font-weight: 600;
  color: var(--cl-dark, #1f2937);
}

.mediaViewer__videoPreview {
  width: 100%;
  max-height: 160px;
  border-radius: 10px;
  background: #0f172a;
}

.mediaViewer__fileLink {
  color: #1677ff;
}

.mediaViewer__overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.85);
  z-index: 3100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.mediaViewer__close {
  position: absolute;
  top: 16px;
  right: 18px;
  border: none;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  border-radius: 999px;
  width: 42px;
  height: 42px;
  font-size: 28px;
  cursor: pointer;
}

.mediaViewer__content {
  width: min(1100px, 100vw - 48px);
  max-height: calc(100vh - 48px);
  display: grid;
  gap: 12px;
}

.mediaViewer__toolbar {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.mediaViewer__toolbar button,
.mediaViewer__toolbar a {
  border: none;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
  text-decoration: none;
}

.mediaViewer__stage {
  flex: 1 1;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.mediaViewer__image {
  max-width: 100%;
  max-height: calc(100vh - 140px);
  -webkit-user-select: none;
          user-select: none;
  transition: transform 120ms ease;
}

.mediaViewer__video,
.mediaViewer__audio {
  width: 100%;
  max-height: calc(100vh - 140px);
  border-radius: 14px;
  background: #0f172a;
}

@media (max-width: 768px) {
  .mediaViewer__overlay {
    padding: 10px;
  }
  .mediaViewer__content {
    width: calc(100vw - 20px);
    max-height: calc(100vh - 20px);
  }
  .mediaViewer__thumb {
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/MediaViewer/MediaViewer.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;;EAEE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,mCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;EACA,QAAA;EACA,kCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,gCAAA;EACA,8BAAA;EACA,aAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;;EAEE,YAAA;EACA,qCAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,+BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gCAAA;AACF;;AAEA;;EAEE,WAAA;EACA,+BAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;EAEA;IACE,yBAAA;IACA,8BAAA;EAAF;EAGA;IACE,eAAA;EADF;AACF","sourcesContent":[".mediaViewer {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.mediaViewer__thumbBtn,\n.mediaViewer__previewCard {\n  border: none;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n}\n\n.mediaViewer__thumb {\n  max-width: 220px;\n  max-height: 160px;\n  border-radius: 12px;\n  display: block;\n}\n\n.mediaViewer__previewCard {\n  display: grid;\n  gap: 8px;\n  width: min(260px, 100%);\n  padding: 10px;\n  border-radius: 14px;\n  border: 1px solid var(--cl-border, #d8dde6);\n  background: var(--cl-surface, #fff);\n}\n\n.mediaViewer__previewLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--cl-dark, #1f2937);\n}\n\n.mediaViewer__videoPreview {\n  width: 100%;\n  max-height: 160px;\n  border-radius: 10px;\n  background: #0f172a;\n}\n\n.mediaViewer__fileLink {\n  color: #1677ff;\n}\n\n.mediaViewer__overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.85);\n  z-index: 3100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.mediaViewer__close {\n  position: absolute;\n  top: 16px;\n  right: 18px;\n  border: none;\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n  border-radius: 999px;\n  width: 42px;\n  height: 42px;\n  font-size: 28px;\n  cursor: pointer;\n}\n\n.mediaViewer__content {\n  width: min(1100px, calc(100vw - 48px));\n  max-height: calc(100vh - 48px);\n  display: grid;\n  gap: 12px;\n}\n\n.mediaViewer__toolbar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.mediaViewer__toolbar button,\n.mediaViewer__toolbar a {\n  border: none;\n  background: rgba(255, 255, 255, 0.14);\n  color: #fff;\n  border-radius: 10px;\n  padding: 8px 12px;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.mediaViewer__stage {\n  flex: 1;\n  min-height: 320px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.mediaViewer__image {\n  max-width: 100%;\n  max-height: calc(100vh - 140px);\n  user-select: none;\n  transition: transform 120ms ease;\n}\n\n.mediaViewer__video,\n.mediaViewer__audio {\n  width: 100%;\n  max-height: calc(100vh - 140px);\n  border-radius: 14px;\n  background: #0f172a;\n}\n\n@media (max-width: 768px) {\n  .mediaViewer__overlay {\n    padding: 10px;\n  }\n\n  .mediaViewer__content {\n    width: calc(100vw - 20px);\n    max-height: calc(100vh - 20px);\n  }\n\n  .mediaViewer__thumb {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
